/** Local calendar date as yyyy-MM-dd (toISOString would shift it to UTC). */
export const toLocalIso = (d) => {
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${mm}-${dd}`;
};

/** First day of the month `monthsBack` months before the current one. */
export const startOfMonthsAgo = (monthsBack, now = new Date()) =>
  new Date(now.getFullYear(), now.getMonth() - monthsBack, 1);

/** Last day of the month containing `d`. */
export const endOfMonth = (d) => new Date(d.getFullYear(), d.getMonth() + 1, 0);

export const UNCATEGORIZED = 'uncategorized';

/** Display name of a category row from the spending report. */
export const categoryName = (category, t, language) => {
  if (!category || category.key === UNCATEGORIZED) return t('budget.uncategorized');
  return (language === 'tr' ? category.nameTr : category.nameEn) || category.key;
};

/** Share of `part` in `whole` as a whole-number percentage. */
export const percentOf = (part, whole) => {
  const w = Number(whole);
  return w > 0 ? Math.round((Number(part) / w) * 100) : 0;
};
